// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class EditLock {
  readonly entityId: string;
  readonly editorId: string;
  readonly editorName: string;
  readonly expiresAt: DateTime;

  constructor(data: { [key: string]: any } = {}) {
    this.entityId = data.entityId === undefined ? NIL_UUID : data.entityId;
    this.editorId = data.editorId === undefined ? NIL_UUID : data.editorId;
    this.editorName = data.editorName === undefined ? '' : data.editorName;
    this.expiresAt = DateHelpers.ParseServerDateTime(data.expiresAt);
  }

  static zero(): EditLock {
    const zeroValues: ExcludeMethodsDeep<EditLock> = {
      entityId: NIL_UUID,
      editorId: NIL_UUID,
      editorName: '',
      expiresAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
    };
    return new EditLock(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type EditLockWireFormat = {
  entityId: string;
  editorId: string;
  editorName: string;
  expiresAt: string;
};

type NewEditLockProps = PartialDeep<EditLock, { recurseIntoArrays: true }>;
export const NewEditLock: (props: NewEditLockProps) => EditLock = (props) => new EditLock(props);

type NewEditLockFromWireFormatProps = PartialDeep<EditLockWireFormat, { recurseIntoArrays: true }>;
export const NewEditLockFromWireFormat: (props: NewEditLockFromWireFormatProps) => EditLock = (
  props,
) => new EditLock(props);
